// extracted by mini-css-extract-plugin
export default {"auto":"Auto_auto__fQY0m","cycler":"Auto_cycler__iXI1-","control":"Auto_control__XNGdt","description":"Auto_description__Kvf+x","progressBar":"Auto_progressBar__l73M7"};